module.exports = __webpack_public_path__ + "img/portraitLaurent.4ad6eb42.jpg";